import API from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../../i18n';
import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ProtectedRouteContext } from '../../../Context';

import './SingleLinePlainText.scss';

export default function SingleLinePlainText(props) {
    /**
     * @type {ShipyardQuestion}
     */
    const question = props.question;
    const disabled = props.disabled;
    const answerUpdated = props.answerUpdated;
    const appInstanceId = props.appInstanceId;

    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );
    const [showErrors, setShowErrors] = useState(props.shouldShowErrors);
    const [value, setValue] = useState(question.answerText);
    const [saving, setSaving] = useState(false);
    const [preSaveVal, setPreSaveVal] = useState(question.answerText + '');
    const [masking, setMasking] = useState(true);

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    useEffect(() => {
        setShowErrors(props.shouldShowErrors);
    }, [props]);

    const onBlur = async (_event) => {
        if (preSaveVal === value || !question.isValid) {
            setShowErrors(question.isValid === false);
            return;
        }

        setSaving(true);
        try {
            var updateAnswerResponse = await API.put('ShipyardAPI', `/application/${appInstanceId}/answer/${question.id}`, {
                body: { responseText: value },
            });
        } catch (apiErr) {
            toast.error(t('General.AjaxError'));
            setValue(preSaveVal);
            setSaving(false);
            return;
        }

        if (!updateAnswerResponse.success) {
            toast.error(t('General.AjaxError'));
            setValue(preSaveVal);
            setSaving(false);
            return;
        }

        setSaving(false);
        setPreSaveVal(value);
    };

    const onValueChange = async (event) => {
        const newVal = event.target.value;
        question.answerText = newVal;
        setValue(newVal);
        var validity = question.validator(question);
        question.isValid = validity.isValid;
        question.invalidReason = validity.invalidReason;
        answerUpdated();
    };

    const toggleMask = (event) => {
        event.preventDefault();
        setMasking(!masking);
    };

    return (
        <div className={'question-wrapper plaintext' + (!question.isValid && showErrors ? ' invalid' : '') + (disabled ? ' disabled' : '')}>
            <label htmlFor={`quest-${question.id}`}>
                <div className={classNames({ label: true, 'label-plain': true, required: question.minResponseRequired > 0 })}>
                    <ReactMarkdown
                        children={question.text[lang]}
                        linkTarget="_blank"
                    />
                </div>
                {saving ? (
                    <span className="saving">
                        <FontAwesomeIcon icon={faSpinner} />
                    </span>
                ) : null}
            </label>
            <input
                aria-labelledby={`quest-${question.id}-err`}
                disabled={saving}
                id={`quest-${question.id}`}
                onBlur={onBlur}
                onChange={onValueChange}
                type={question.masked & masking ? 'password' : 'text'}
                value={value}
            />
            {!question.masked ? null : (
                <FontAwesomeIcon
                    className="mask-icon"
                    icon={masking ? faEyeSlash : faEye}
                    onClick={toggleMask}
                />
            )}
            <span
                className="invalid-reason"
                id={`quest-${question.id}-err`}
            >
                {typeof question.invalidReason === 'string'
                    ? t(question.invalidReason)
                    : question.invalidReason[userSettings.LanguagePreference]}
            </span>
        </div>
    );
}
